module.exports = __webpack_public_path__ + "media/hyper/images/products/product-1-b2d8d0bd51b1321c1e6fc9857c8a91a9.jpg";